import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPeople: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPeople"><Path d="M12 2C9.51472 2 7.5 4.01472 7.5 6.5C7.5 8.98528 9.51472 11 12 11C14.4853 11 16.5 8.98528 16.5 6.5C16.5 4.01472 14.4853 2 12 2Z" fill="currentColor"/><Path d="M12.0008 12C7.24298 12 3.91741 15.5211 3.50515 19.9064L3.40234 21H20.5992L20.4964 19.9064C20.0841 15.5211 16.7585 12 12.0008 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPeople;
